import { createSlice } from '@reduxjs/toolkit'

export const accountSlice = createSlice({
  name: 'account',
  initialState: {
    open: false,
    email: '',
    customer: null,
    firstCall: false,
    registerTitle: false,
    additionalFields: true
  },
  reducers: {
    setOpen: (state, action) => {
      state.open = action.payload
    },
    setEmail: (state, action) => {
      state.email = action.payload
    },
    setCustomer: (state, action) => {
      state.customer = action.payload
    },
    setFirstCall: (state, action) => {
      state.firstCall = action.payload
    },
    setRegisterTitle: (state, action) => {
      state.registerTitle = action.payload
    },
    setAdditionalFields: (state, action) => {
      state.additionalFields = action.payload
    }
  },
})

export const { setOpen, setEmail, setCustomer, setFirstCall, setRegisterTitle, setAdditionalFields } = accountSlice.actions

export default accountSlice.reducer
